import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const searchRegionalGuidance = api(async function searchRegionalGuidance({ codeOfPracticeId }) {
    return mutate(
        gql`
            mutation SearchRegionalGuidance($codeOfPracticeId: ID!) {
                searchRegionalGuidance(codeOfPracticeId: $codeOfPracticeId)
            }
        `,
        { codeOfPracticeId },
        { returns: "searchRegionalGuidance" }
    )
})
